import { useMemo, useState } from "react";
import { Section } from "../../../../components/CustomLayout/CustomLayoutStyles";
import useEmpresa from "../../../../hooks/useEmpresa";
import CustomSelect from "../../../../components/CustomForm/CustomSelect";
import {
  FormWrapper,
  FormGroup
} from "../../../../components/CustomForm/FormStyles";
import Colors from "../../../../themes/Colors";
import CustomButton from "../../../../components/CustomButton/CustomButton";
import CustomTable from "../../../../components/CustomTable/CustomTable";
import { DeleteOutlined } from "@ant-design/icons";
import Tooltip from "../../../../components/Common/Tooltip";
import Titulo from "../../shared/Titulo";

const PrecertificacionProcedimientos = (props) => {
  const {
    coberturas,
    coberturasSeleccionadas,
    cargando,
    onSeleccionarCobertura,
    onEliminarCobertura
  } = props;
  const empresa = useEmpresa();
  const [coberturaSeleccionada, setCoberturaSeleccionada] = useState(null);

  const columnas = useMemo(
    () => [
      {
        title: "Procedimiento",
        dataIndex: "nombreCobertura",
        key: "nombreCobertura",
        width: "80%"
      },
      {
        title: "",
        dataIndex: "eliminar",
        key: "eliminar",
        width: "20%",
        render: (_text, record) => (
          <Tooltip text="Remover">
            <DeleteOutlined
              style={{ color: Colors.huMyHealth, fontSize: 25 }}
              onClick={() => {
                onEliminarCobertura(record);
              }}
            />
          </Tooltip>
        )
      }
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <>
      <Titulo titulo={"PROCEDIMIENTOS"} />

      <Section>
        <FormWrapper borderColor={Colors.transparent} padding={"0 20px"}>
          <FormGroup
            flexDirection={"row"}
            justifyContent={"start"}
            gap={"10px"}
            width={"100%"}
          >
            <CustomSelect
              minWidth={"400px"}
              font={empresa?.LETRA_PRINCIPAL}
              showDefaultOption={true}
              options={coberturas.map((item) => ({
                value: item.codigoCobertura,
                label: item.nombreCobertura
              }))}
              value={coberturaSeleccionada?.codigoCobertura}
              onChange={(value) => {
                setCoberturaSeleccionada(
                  coberturas.find(
                    (item) => item.codigoCobertura === Number(value)
                  )
                );
              }}
            />

            <CustomButton
              label={"Agregar"}
              isLoading={cargando}
              onClick={() => {
                if (coberturaSeleccionada) {
                  onSeleccionarCobertura(coberturaSeleccionada);
                }
              }}
            />
          </FormGroup>
        </FormWrapper>
      </Section>

      <Section>
        <CustomTable
          columns={columnas}
          dataSource={coberturasSeleccionadas}
          showPagination={false}
          pageSize={10}
          width={"95%"}
          minHeight={"150px"}
          maxHeight={"400px"}
        />
      </Section>
    </>
  );
};

export default PrecertificacionProcedimientos;
